import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formsWriteAccess", "hasCopilotCreateFormGate", "isPortalZeroState", "isRequestStatePending", "onClick"];
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { getFormCreationRequestState } from 'FormsUI/selectors/FormCreation';
import { hasFormsWriteAccess } from 'FormsUI/selectors/Scope';
import { push as pushAction } from 'FormsUI/actions/HistoryActions';
import isAcceptanceTest from 'forms-utils-lib/localStorage/isAcceptanceTest';
import { trackScreen } from 'FormsUI/utils/TrackingUtils';
import FormCreationButton from 'FormsUI/components/dashboard/FormCreationButton';
import { isUngatedForFormTemplates, isUngatedForCopilotCreateForm } from 'FormsUI/selectors/Gates';
import StartWithAIButton from 'FormsUI/components/dashboard/createForm/StartWithAIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormCreationButtonContainer = _ref => {
  let {
      formsWriteAccess,
      hasCopilotCreateFormGate,
      isPortalZeroState,
      isRequestStatePending,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  useEffect(() => {
    const isAcceptanceTestResult = isAcceptanceTest();
    if (isPortalZeroState && !isAcceptanceTestResult) {
      trackScreen('dashboard', 'manage', {
        state: 'view-from-zero-state'
      });
    }
  }, [isPortalZeroState]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [hasCopilotCreateFormGate && /*#__PURE__*/_jsx(StartWithAIButton, {
      formsWriteAccess: formsWriteAccess,
      isRequestStatePending: isRequestStatePending
    }), /*#__PURE__*/_jsx(FormCreationButton, Object.assign({
      formsWriteAccess: formsWriteAccess,
      onClick: onClick,
      isPortalZeroState: isPortalZeroState,
      isRequestStatePending: isRequestStatePending
    }, rest))]
  });
};
const mapStateToProps = state => ({
  formsWriteAccess: hasFormsWriteAccess(state),
  hasCopilotCreateFormGate: isUngatedForCopilotCreateForm(state),
  hasFormTemplatesGate: isUngatedForFormTemplates(state),
  isRequestStatePending: getFormCreationRequestState(state).isPending()
});
const actionToBind = {
  push: pushAction
};
export default connect(mapStateToProps, actionToBind)(FormCreationButtonContainer);